'use client';

import Error from './[lang]/(with-layout)/error';

export default ({ error }) => {
  return (
    <div className="h-[100vh]">
      <Error error={error} />
    </div>
  );
};
